/*
 * クイズ作成画面における自動更新の制御と更新したことをプレビューの上部に表示する
 */

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import dayjs from '../../../../commons/plugins/dayjs'
import * as styles from './EditorTimer.css'

class EditorTimer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      interval: null,
      lastSaveTime: null,
      updateMessage: `${props.lastUpdateTime.fromNow()}に保存しました`
    }
  }
  timer(timerFunction, intervalTime, isEnabled) {
    // 毎秒更新する
    const now = dayjs()
    const diff = now.diff(this.props.lastUpdateTime, 'seconds')
    this.setState({ updateMessage: '保存しています...' })
    // 基準時間との差がinterval以上になったら、関数を実行
    if (isEnabled && diff >= intervalTime) {
      timerFunction()
      this.setState({
        updateMessage: '変更内容を保存しました',
        lastSaveTime: this.props.lastUpdateTime
      })
    }
  }
  render() {
    const { isEnabled, intervalTime, timerFunction } = this.props

    if (!isEnabled) {
      clearInterval(this.state.interval)
      this.setState({ interval: null })
    }

    if (this.state.interval === null && isEnabled) {
      // 1秒ごとにポーリング
      const interval = setInterval(() => {
        // FIXME: これだと最初に渡すlastUpdatedTimeで固定されてしまう
        this.timer(timerFunction, intervalTime, isEnabled)
      }, 1000)

      this.setState({ interval: interval })
    }
    return <p className={styles.label}>{this.state.updateMessage}</p>
  }
}

EditorTimer.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  intervalTime: PropTypes.number.isRequired,
  timerFunction: PropTypes.func.isRequired,
  lastUpdateTime: PropTypes.object
}

EditorTimer.defaultProps = {
  isEnabled: false,
  intervalTime: 2
}

export default EditorTimer
